// <div data-controller="notes--edit-publishing">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";
import helpers from "@/utils/helpers";

const PREVIEW_TYPES = ["product", "membership_only", "subscriber_only"];
const PRICE_TYPES = ["product"];

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [
    "postingTypeOptions", "priceOptions", "previewDataOption",
    "postScheduleCheckbox", "postSchedulePanel",
    "cancelPostScheduleCheckbox", "postScheduleFields",
    "scheduledPostingType",
    "previewModeRadio", "previewRangePanel", "previewCustomPanel",
    "previewBlocksCountInput", "previewBlocksCountLabel", "previewRangeBlock"
  ];
  static classes = [ "" ]
  static values = {};

  initialize() {

  }

  get checkedPostingType() {
    const postingOptions = this.postingTypeOptionsTarget.options;
    return postingOptions[postingOptions.selectedIndex].value;
  }

  get activeScheduledPostingType() {
    if (!this.hasScheduledPostingTypeTarget) return null;

    // 취소 체크되어 있으면 무시
    if (this.hasCancelPostScheduleCheckboxTarget && this.cancelPostScheduleCheckboxTarget.checked) return null;

    // 새로 만드는 모드에서 체크박스 안 눌렀으면 무시
    if (this.hasPostScheduleCheckboxTarget && !this.postScheduleCheckboxTarget.checked) return null;

    const select = this.scheduledPostingTypeTarget;
    return select.options[select.selectedIndex].value;
  }

  updateFieldVisibility() {
    const postingType = this.checkedPostingType;
    const scheduledType = this.activeScheduledPostingType;

    const needsPrice = PRICE_TYPES.includes(postingType) || PRICE_TYPES.includes(scheduledType);
    const needsPreview = PREVIEW_TYPES.includes(postingType) || PREVIEW_TYPES.includes(scheduledType);

    this.priceOptionsTarget.classList.toggle("hidden", !needsPrice);
    this.previewDataOptionTarget.classList.toggle("hidden", !needsPreview);

    if (needsPreview) {
      this.onPreviewModeChange();
    }
  }

  get selectedPreviewMode() {
    if (!this.hasPreviewModeRadioTarget) return "range";
    const checked = this.previewModeRadioTargets.find(r => r.checked);
    return checked ? checked.value : "range";
  }

  onPreviewModeChange = () => {
    if (!this.hasPreviewRangePanelTarget || !this.hasPreviewCustomPanelTarget) return;
    const mode = this.selectedPreviewMode;
    this.previewRangePanelTarget.classList.toggle("hidden", mode !== "range");
    this.previewCustomPanelTarget.classList.toggle("hidden", mode !== "custom");
    if (mode === "range") this.applyPreviewBlocksCount();
  }

  onPreviewBlocksCountChange = () => {
    this.applyPreviewBlocksCount();
  }

  applyPreviewBlocksCount = () => {
    if (!this.hasPreviewBlocksCountInputTarget) return;
    const input = this.previewBlocksCountInputTarget;
    const total = this.previewRangeBlockTargets.length;
    let n = parseInt(input.value, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (total > 0 && n > total) n = total;
    input.value = n;

    this.previewRangeBlockTargets.forEach((el, idx) => {
      el.classList.toggle("hidden", idx >= n);
    });

    if (this.hasPreviewBlocksCountLabelTarget) {
      this.previewBlocksCountLabelTarget.textContent = String(n);
    }
  }

  // 하위 호환: 기존 onChangePostingType 호출이 있을 수 있으므로 유지
  onChangePostingType() {
    this.updateFieldVisibility();
  }

  togglePostSchedule() {
    if (this.hasPostSchedulePanelTarget) {
      const checked = this.postScheduleCheckboxTarget.checked;
      this.postSchedulePanelTarget.classList.toggle("hidden", !checked);
    }
    this.updateFieldVisibility();
  }

  toggleCancelPostSchedule() {
    if (this.hasPostScheduleFieldsTarget) {
      const checked = this.cancelPostScheduleCheckboxTarget.checked;
      const fields = this.postScheduleFieldsTarget.querySelectorAll("input, select");
      fields.forEach(field => {
        field.disabled = checked;
      });
      this.postScheduleFieldsTarget.classList.toggle("opacity-50", checked);
    }
    this.updateFieldVisibility();
  }

  connect() {
    this.updateFieldVisibility();
  }

  disconnect() {

  }
}
